import React from 'react'
import { translate } from 'react-i18next'
import { compose, pure } from 'recompose'
import { Link } from 'react-router-dom'
import routes from '../../routes/root/routes'
import styles from './gradPlannerNavComponent.scss'
import SmallNav from '../smallNav/smallNavComponent'
import ContentContainer from '../contentContainer/contentContainerComponent'
import PropTypes from 'prop-types'
export function GradPlannerNav (props: Props) {
  const { t } = props
  return (
    <header className={styles.fixed}>
      <SmallNav />
      <div className={styles.appHeader}>
        <ContentContainer element='nav' className={styles.headerNav}>
          {props.plan.school && <p>{props.plan.school.name}</p>}
          <div className={styles.navButtons}>
            {props.isDirty && (
              <button className={styles.linkButton} onClick={props.reset}>
                <span>{t('gradPlanner:startOver')}</span>
              </button>
            )}
            <Link to={routes.home}>
              <span>{t('gradPlanner:quit')}</span>
            </Link>
          </div>
        </ContentContainer>
      </div>
    </header>
  )
}
GradPlannerNav.propTypes = {
  t: PropTypes.func.isRequired,
  isDirty: PropTypes.bool.isRequired,
  reset: PropTypes.func.isRequired,
  plan: PropTypes.object
}

export default compose(pure, translate())(GradPlannerNav)



// WEBPACK FOOTER //
// ./src/components/gradPlannerNav/gradPlannerNavComponent.js